module.exports = __webpack_public_path__ + "img/active-user.db67155f.svg";